import type {FundamentalLikeNode} from "#template/role-markers"
import {createFundamentalMarker} from "#template/role-markers"
import type {ObjectData} from "#template/nodes/object/types"

export const objectLikeMarker = Symbol("ObjectLike")

export interface ObjectLikeNode extends FundamentalLikeNode<ObjectData | null> {
    readonly [objectLikeMarker]: true
}

export const objectMarker = createFundamentalMarker<ObjectLikeNode>(objectLikeMarker)
export const {isLikeNode: isObjectLikeNode, isLikeNodeClass: isObjectLikeNodeClass, like: objectLike} = objectMarker
